import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

type SidebarAdStackProps = {
  children: ReactNode;
  className?: string;
};

type SidebarAdItemProps = {
  children: ReactNode;
  className?: string;
};

export function SidebarAdStack({ children, className }: SidebarAdStackProps) {
  return <div className={cn('w-full max-w-[340px] space-y-6', className)}>{children}</div>;
}

export function SidebarAdItem({ children, className }: SidebarAdItemProps) {
  return <div className={cn('w-full', className)}>{children}</div>;
}
